import React from "react";
import "./styles.scss";
import { Scroll } from "atoms";
import { HeaderTagline } from "molecules";

export default props => (
  <div id={props.id} className="card-banner">
    <div className={props.showScroll ? "card-banner-container with-scroll" : "card-banner-container"}>
      <HeaderTagline h1={props.h1} 
                     h3={props.h3}
                     h5={props.h5}
                     purchaseAction={props.purchaseAction} 
                     showBuyMeACoffee={props.showBuyMeACoffee}/>
      <img src={props.image} alt="Nalu logo"/>
    </div>
    {props.showScroll && <Scroll/>}
  </div>
);
